const warehouseManagementType = {
	daVinci: 'da%20vinci',
	extensiv: 'extensiv',
	zethcon: 'zethcon',
};

export { warehouseManagementType };
